<sw-page class="topdata-llm-connect-llm-model-detail-page">
    <template #smart-bar-header>
        <h2>{{ pageTitle }}</h2>
    </template>

    <template #smart-bar-actions>
        <sw-button size="small" @click="onCancel">
            {{ $tc('global.default.cancel') }}
        </sw-button>
        <sw-button variant="primary" size="small" @click="onSave" :isLoading="isLoading">
            {{ $tc('global.default.save') }}
        </sw-button>
    </template>

    <template #content>
        <sw-card-view v-if="item">
            <sw-card :title="$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.cardGeneral')" position-identifier="topdata-llm-connect-llm-model-detail-general">
                <mt-select
                    v-model="item.providerId"
                    required
                    :label="$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.labelProvider')"
                    :options="providerOptions"
                ></mt-select>

                <sw-text-field
                    v-model="item.model"
                    required
                    :label="$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.labelModel')"
                    :placeholder="$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.placeholderModel')"
                ></sw-text-field>

                <sw-text-field
                    v-model="item.displayName"
                    required
                    :label="$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.labelDisplayName')"
                ></sw-text-field>

                <mt-switch
                    v-model="item.active"
                    :label="$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.labelActive')"
                ></mt-switch>

                <mt-switch
                    v-model="item.isFavorite"
                    :label="$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.labelFavorite')"
                ></mt-switch>
            </sw-card>
        </sw-card-view>
    </template>
</sw-page>
